// File templates for new file creation

export function getFileTemplate(filePath, customContent = '') {
  if (customContent) {
    return customContent;
  }

  const extension = filePath.split('.').pop().toLowerCase();

  switch (extension) {
    case 'html':
      return getHTMLTemplate(filePath);

    case 'css':
      return getCSSTemplate();

    case 'js':
      return getJSTemplate();

    default:
      return '';
  }
}

function getHTMLTemplate(filePath) {
  const fileName = filePath.split('/').pop().replace('.html', '');
  const title = fileName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${title}</title>
  <link rel="stylesheet" href="/css/style.css">
</head>
<body>
  <h1>${title}</h1>
  <p>This is a new page.</p>
</body>
</html>`;
}

function getCSSTemplate() {
  return `/* Styles */

body {
  margin: 0;
  padding: 0;
  font-family: system-ui, -apple-system, sans-serif;
}
`;
}

function getJSTemplate() {
  return `// JavaScript

(function() {
  'use strict';

  // Your code here

})();
`;
}

export function validateFilePath(filePath) {
  // Must start with /
  if (!filePath.startsWith('/')) {
    return { valid: false, error: 'File path must start with /' };
  }

  // No path traversal
  if (filePath.includes('..')) {
    return { valid: false, error: 'File path cannot contain ..' };
  }

  // Must have extension
  if (!filePath.includes('.')) {
    return { valid: false, error: 'File must have an extension' };
  }

  // Supported extensions
  const extension = filePath.split('.').pop().toLowerCase();
  const supportedExtensions = ['html', 'css', 'js', 'txt', 'json', 'svg', 'xml'];

  if (!supportedExtensions.includes(extension)) {
    return {
      valid: false,
      error: `Unsupported extension .${extension}. Supported: ${supportedExtensions.join(', ')}`
    };
  }

  // Valid characters only
  const validPathRegex = /^[a-zA-Z0-9/_.-]+$/;
  if (!validPathRegex.test(filePath)) {
    return { valid: false, error: 'File path contains invalid characters' };
  }

  return { valid: true };
}
